// Keys mirror the `portal` block on the golfid-api application model.
// Adding a toggle here (and in golfid-api/modules/portal-settings.js) is all that is
// needed for it to appear in the Portal Settings capsule.
const PortalSettings = [
    { group: 'Layout', key: 'hideHeader', label: 'Hide header' },
    { group: 'Layout', key: 'hideBanner', label: 'Hide banner' },
    { group: 'Layout', key: 'hideLogos', label: 'Hide main logo' },
    { group: 'Layout', key: 'hideFooter', label: 'Hide footer (also hides banner)' },
    { group: 'Properties', key: 'hideProperties', label: 'Hide properties', help: 'Takes precedence over alternate properties.' },
    { group: 'Properties', key: 'useAlternateProperties', label: 'Use alternate properties', help: 'Shows the alternate properties in place of the default list.' },
    { group: 'Login Form', key: 'hideForgot', label: 'Hide forgot password and reCAPTCHA notice', help: 'Only hides the link and notice; reCAPTCHA verification still runs.' },
    { group: 'Login Form', key: 'hideCreate', label: 'Hide create account' },
    { group: 'Login Form', key: 'hideSelectUser', label: 'Hide select user' },
    { group: 'Login Form', key: 'useGnButton', label: 'Use GolfNow login button' },
    { group: 'Login Form', key: 'showSteps', label: 'Show step titles' },
    { group: 'Branding', key: 'showAppIcon', label: 'Show app icon above step titles', help: 'GolfNow (/gn) page only.' }
];

export default PortalSettings;
